export default __webpack_public_path__ + "static/media/DAIF_Eco_Screen2_in.a510f25b.mp4";